<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: red" icon="newspaper"></font-awesome-icon>
            <a  class="mainblock-label">资源列表</a>
          </div>

        </div>
        <div class="container-body panel-party">
          <div style="width: 250px">
              <el-menu @select="moduleClick">
                <el-submenu v-for="nm in newsModule" :key="nm.value" :index="nm.value">
                  <template slot="title">
                    <span>{{nm.label}}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item v-for="cnm in nm.children" :key="cnm.value" :index="cnm.value">{{cnm.label}}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
          </div>
          <div class="party-right">
            <div class="party-block">
              <div><span style="color: blue;font-size: 20px;">{{currentModuleName}}</span></div>
              <ul >
                <li v-for="news in newsList">
                    <div @click="toDeatail(news.dataId)" style="cursor: pointer;">
                      {{news.title}}<span style="color: orange;font-size: 14px;">来源:[{{news.source}}]</span>
                    </div>
                </li>
              </ul>
              <el-button type="primary" v-show="pagePreShow" v-on:click="prePage()">上一页</el-button>
              <el-button type="primary" v-show="pageNextShow" v-on:click="nextPage()">下一页</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
@import "../../assets/less/variables.less";
@import "../../assets/less/mySearch.less";
@import "../../assets/less/style.less";
</style>

<script type="text/ecmascript-6">
import viewFunction from "../../assets/js/viewFunction";
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Training',
  inject:['check'],
  data(){
    return {
      newsList: [],
      currentModule: '',
      currentModuleName: '',
      pagePreShow: false,
      pageNextShow: false,
      pageNum:1,
      pageSize:20,
      newsModule:[
        {
          value: '1',
          label: '专业技能',
          children: [
            {value: '1,3', label: '岗位技能'},
            {value: '1,4', label: '管理改善'},
            {value: '1,5', label: '精品课程'},
            {value: '1,16', label: '专题培训'}]
        },
        {
          value: '17',
          label: '安全培训',
          children: [
            {value: '19', label: '安全知识'},
            {value: '18', label: '安全文件'},
            {value: '20', label: '安全视频'},
            {value: '21', label: '安全专题'}]
        },
        {
          value: '22',
          label: '三基建设',
          children: [
            {value: '22,23', label: '班组园地'},
            {value: '6,16', label: '能工巧匠'},
            {value: '22,24', label: '他山之石'}]
        }
      ]
    }
  },
  mounted() {
    this.findAllData("")
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    ...mapGetters({
      navigationList: 'navs'
    })
  },
  methods:{
    moduleClick(index){
      this.pageNum = 1
      this.getLabel(index)
      this.currentModule = index
      this.findAllData(index)
    },
    getLabel(value){
      // 遍历查找
      for (const item of this.newsModule) {
        if (item.children) {
          for (const child of item.children) {
            if (child.value === value) {
              this.currentModuleName = item.label + ">" + child.label
              return;
            }
          }
        }
      }
    },
    toDeatail(newsId){
      let user = this.user
      if (user== null){
        this.check()
      }else {
        this.$router.push({
          path:'/NewsDetail',
          query:{
            newsId:newsId
          }
        })
      }

    },
    findAllData(){
      var params = {
        pageNum:this.pageNum,
        pageSize: this.pageSize,
        module:this.currentModule
      }
      //let url = '/api/newsView/findNewsListForWeb'
      let url = '/api/newsView/findNewsList'
      let that = this
      this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
        that.newsList = res.data
        if(that.pageNum === 1){
          that.pagePreShow = res.data.length === that.pageSize
        }else{
          that.pagePreShow = res.data.length > 0
        }
        that.pageNextShow = res.data.length === that.pageSize
      }))
    },
    prePage(){
      if(this.pageNum > 1){
        this.pageNum = this.pageNum - 1
        this.findAllData(this.currentModule)
      }else{
        this.$message({
          message: '已经是第一页',
          type: 'warning'
        });
      }
    },
    nextPage(){
      this.pageNum = this.pageNum + 1
      this.findAllData(this.currentModule)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/learn/NewsList.vue